// Canonical fan-type set. Kept in sync with /app/backend/server.py FAN_TYPES.
// Server is authoritative — this file is a UI convenience so the app can render
// chips without waiting on /profile/fan-types.
export const FAN_TYPES = [
  { id: "home_and_away",     label: "Home & away regular", tag: "Home & away" },
  { id: "home_only",         label: "Home games only",      tag: "Home only" },
  { id: "pub_every_match",   label: "Local pub every match", tag: "Pub every match" },
  { id: "armchair_loyal",    label: "Armchair loyal",       tag: "Armchair loyal" },
  { id: "watch_when_i_can",  label: "Watch when I can",     tag: "Watch when I can" },
  { id: "new_to_club",       label: "New to following the club", tag: "New to the club" },
];

export const labelForFanType = (id) => FAN_TYPES.find(f => f.id === id)?.label || id;
export const tagForFanType = (id) => FAN_TYPES.find(f => f.id === id)?.tag || id;
